/**
 * Statuses this rule keys off. They must match `REPAIR_ORDER_STATUS` on the backend
 * (warp_portal/apps/repair_orders/constants.py).
 */
const NOT_STARTED = 'Not Started'
const ON_OUTSTANDING_LIST = 'On Outstanding List'

/**
 * Whether a move onto the Outstanding List has to carry an Advisor #.
 *
 * The Advisor # is never carried over from a previous stint on the list, so it has to be
 * entered on every move onto it. A dealer-closed claim is the one exemption: it goes onto
 * the list as an already-closed RO and never reaches Dealer Review — the transition that
 * actually needs an advisor — so requiring one would make it unaddable.
 *
 * That exemption belongs to the move *out of Intake*, not to the flag. `dealerClosed`
 * stays set for the life of the RO, so keying off it alone went on exempting every later
 * transition too, letting a `Closed — Submitted` claim back onto the list with a blank
 * Advisor # even though it was about to be worked.
 *
 * Mirrors `RepairOrderSerializer.validate`. Lives apart from the modal so it can be
 * tested as the pure predicate it is.
 *
 * @param {object} args
 * @param {string} args.selectedStatus status the user is moving the RO to
 * @param {string} args.currentStatus status the RO has right now
 * @param {boolean} args.dealerClosed dealer-closed flag as the request will send it
 */
export const isAdvisorRequiredForOl = ({ selectedStatus, currentStatus, dealerClosed }) =>
  selectedStatus === ON_OUTSTANDING_LIST && !(dealerClosed && currentStatus === NOT_STARTED)
